// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__nKtzf","list":"styles_list__2-XGS"};